/**
 * Decodes an `ImageTexture3D`, whose `_images` hold its slices as inline `Image` sub-resources
 * (`scene/resources/image_texture.cpp:467-505`), to the volume's texels. No THREE.
 */
import { splitTopLevel } from '../../../godot/string/string.js';
import { arrayLiteralBody } from '../../../godot/variant/variantParser.js';
import { decodeImageRef } from '../image/decode';
import { stackSlices } from './texels';
/** Null when an image fails to decode or the formats differ, which `_set_images` refuses (`:487`). */
export function decodeImageTexture3D(properties, resources) {
    const images = savedImages(properties._images, resources);
    if (!images || new Set(images.map(({ format }) => format)).size > 1)
        return null;
    return stackSlices(images);
}
/**
 * The `Image` sub-resources `_images` names, decoded, in order. Null when any element names no
 * Image or one `decodeImageRef` declines.
 */
function savedImages(value, resources) {
    const body = value ? arrayLiteralBody(value) : null;
    if (body === null)
        return null;
    const images = [];
    for (const element of splitTopLevel(body)) {
        if (element === '')
            continue;
        const decoded = decodeImageRef(element, resources);
        if (!decoded)
            return null;
        images.push(decoded);
    }
    return images;
}
//# sourceMappingURL=decode.js.map